import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { CampanhaEnviarAnalise } from '../campanha-enviar-analise';
import { CampanhaSearch } from '../../campanha-search';

@Injectable({
    providedIn: 'root'
})
export class CampanhaAnaliseHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/campanha`;
    }


    /** Solicita a análise da campanha */
    solicitar(idCampanha: number): Observable<CampanhaSearch> {
        return this.customHttp.put<CampanhaSearch>(`${this.pathApi}/${idCampanha}/analise/solicitar`, null);
    }


    /** Envia a análise da campanha */
    enviar(idCampanha: number, entity: CampanhaEnviarAnalise): Observable<CampanhaSearch> {
        return this.customHttp.put<CampanhaSearch>(`${this.pathApi}/${idCampanha}/analise/enviar`, entity);
    }
}
